import { render, staticRenderFns } from "./SetBannerInfo.vue?vue&type=template&id=e99ecf46&"
import script from "./SetBannerInfo.vue?vue&type=script&lang=js&"
export * from "./SetBannerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports